<div class="website-audit-management">
  <ng-container *ngIf="!firstLoader">
    <div class="custom-buttons_container second_header_container">
      <h2 class="subtitle-h2">List of created audits</h2>
      <div class="audits-header-actions">
        <label class="custom-input_field_withoutIcon" for="auditsSearch">
          <input
            id="auditsSearch"
            class="custom-input_field"
            [ngModel]="searchTerm"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Search audits"
          />
        </label>
        <button mat-raised-button type="button" (click)="openAddTaskModal()">
          <mat-icon class="button-icon">add</mat-icon>
          <span> Create Audit </span>
        </button>
      </div>
    </div>

    <div
      class="custom_table-container fixed_width_table_container audits-table-container"
    >
      <table class="custom_table">
        <thead>
          <tr>
            <th><div>URL</div></th>
            <th>
              <div class="max-width80">Status</div>
            </th>
            <th><div>Country</div></th>
            <th class="sort-value">
              <div>
                Type
                <svg
                  (click)="toggleTypeSort()"
                  class="custom_table_sort-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    active: sortBy === 'type' && sortDirection === 'asc'
                  }"
                >
                  <path d="M12 8V15" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </th>
            <th class="sort-value">
              <div>
                Frequency
                <svg
                  (click)="toggleFrequencySort()"
                  class="custom_table_sort-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    active: sortBy === 'frequency' && sortDirection === 'asc'
                  }"
                >
                  <path d="M12 8V15" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </th>
            <th class="sort-value">
              <div>
                Active
                <svg
                  (click)="toggleActiveSort()"
                  class="custom_table_sort-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    active: sortBy === 'active' && sortDirection === 'asc'
                  }"
                >
                  <path d="M12 8V15" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 12L12 8" stroke="#5f5d6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </th>
            <th><div></div></th>
          </tr>
        </thead>
      </table>

      <cdk-virtual-scroll-viewport
        *ngIf="tasks?.length > 0"
        [itemSize]="tableItemSize"
        class="table_cdk_scroll audits_cdk_scroll"
        (scrolledIndexChange)="onScrolledIndexChange()"
      >
        <table class="custom_table">
          <tbody>
            <tr
              *cdkVirtualFor="
                let item of tasks;
                let i = index;
                trackBy: trackByTask
              "
            >
            <td
              (click)="item?.status != 'Failed' ? openTask(item) : null"
              [style.cursor]="item?.status != 'Failed' ? 'pointer' : 'default'"
            >
              <div style="display: flex; align-items: center; gap: 8px">
                <span
                  class="ellipsis-text"
                  [matTooltip]="item.url"
                  matTooltipPosition="above"
                >
                  {{ item.url }}
                </span>
                <mat-icon *ngIf="item?.status != 'Failed'" class="button-icon">
                  open_in_new
                </mat-icon>
              </div>
            </td>
            <td>
              <div class="max-width80" *ngIf="item.progress == 100">
                {{ item.status }}
              </div>
              <ng-container *ngIf="item.progress < 100">
                <div class="status-bar">
                  <div
                    class="status-bar-fill"
                    [style.width.%]="item.progress"
                  ></div>
                  <p [style.color]="item.progress > 53 ? '#fff' : 'inherit'">
                    {{ item.progress }}%
                  </p>
                </div>
              </ng-container>
            </td>
            <td>
              {{ item?.params?.country || "-" }}
            </td>
            <td>
              {{ item?.type == "Crawler" ? "Agentic Ecommerce" : "Full Audit" }}
            </td>
            <td>
              <div class="frequency-cell">
                <span
                  class="freq-pill"
                  [class.freq-pill--recurring]="
                    item?.auditFrequency == 'biweekly'
                  "
                >
                  {{
                    item?.auditFrequency == "biweekly"
                      ? "Bi-Weekly"
                      : "One-Time"
                  }}
                </span>
                <button
                  *ngIf="
                    item?.auditFrequency != 'biweekly' &&
                    item?.type != 'Crawler'
                  "
                  class="convert-biweekly-btn"
                  type="button"
                  (click)="convertToBiweekly(item)"
                  [disabled]="item.converting"
                  [matTooltip]="
                    item.converting ? 'Converting…' : 'Convert to bi-weekly'
                  "
                  matTooltipPosition="above"
                  aria-label="Convert to bi-weekly"
                >
                  <mat-icon [class.spinning]="item.converting">
                    autorenew
                  </mat-icon>
                </button>
              </div>
            </td>
            <td>
              <mat-slide-toggle
                *ngIf="item.isActive === true || item.isActive === false"
                [checked]="item.isActive"
                [disabled]="item.activeUpdating"
                (change)="toggleAuditActive(item, $event)"
              ></mat-slide-toggle>
            </td>
            <td>
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  justify-content: flex-end;
                "
              >
                <button
                  class="custom-button"
                  mat-raised-button
                  type="button"
                  (click)="shareAudit(item)"
                  [disabled]="item.status != 'Done'"
                >
                  <div class="button-with-svg">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2473_3050)">
                        <path
                          d="M9 15L15 9"
                          stroke="var(--text-main-color)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11 5.99982L11.463 5.46382C12.4008 4.52614 13.6727 3.99942 14.9989 3.99951C16.325 3.99961 17.5968 4.52651 18.5345 5.46432C19.4722 6.40212 19.9989 7.67401 19.9988 9.00017C19.9987 10.3263 19.4718 11.5981 18.534 12.5358L18 12.9998"
                          stroke="var(--text-main-color)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.0001 18L12.6031 18.534C11.6544 19.4722 10.3739 19.9984 9.03964 19.9984C7.70535 19.9984 6.42489 19.4722 5.47614 18.534C5.0085 18.0716 4.63724 17.521 4.38385 16.9141C4.13047 16.3073 4 15.6561 4 14.9985C4 14.3408 4.13047 13.6897 4.38385 13.0829C4.63724 12.476 5.0085 11.9254 5.47614 11.463L6.00014 11"
                          stroke="var(--text-main-color)"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2473_3050">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span> Share </span>
                  </div>
                </button>
                <button
                  class="custom-button"
                  mat-raised-button
                  type="button"
                  (click)="rerunAudit(item)"
                  [disabled]="
                    item.auditRerunning ||
                    item.status == 'Pending' ||
                    item.status == 'Running'
                  "
                >
                  <div
                    class="button-with-svg"
                    [ngClass]="{ crawl_active: item.auditRerunning }"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 20.75C10.078 20.7474 8.23546 19.9827 6.8764 18.6236C5.51733 17.2645 4.75265 15.422 4.75 13.5C4.75 13.3011 4.82902 13.1103 4.96967 12.9697C5.11032 12.829 5.30109 12.75 5.5 12.75C5.69891 12.75 5.88968 12.829 6.03033 12.9697C6.17098 13.1103 6.25 13.3011 6.25 13.5C6.25 14.6372 6.58723 15.7489 7.21905 16.6945C7.85087 17.6401 8.74889 18.3771 9.79957 18.8123C10.8502 19.2475 12.0064 19.3614 13.1218 19.1395C14.2372 18.9177 15.2617 18.37 16.0659 17.5659C16.87 16.7617 17.4177 15.7372 17.6395 14.6218C17.8614 13.5064 17.7475 12.3502 17.3123 11.2996C16.8771 10.2489 16.1401 9.35087 15.1945 8.71905C14.2489 8.08723 13.1372 7.75 12 7.75H9.5C9.30109 7.75 9.11032 7.67098 8.96967 7.53033C8.82902 7.38968 8.75 7.19891 8.75 7C8.75 6.80109 8.82902 6.61032 8.96967 6.46967C9.11032 6.32902 9.30109 6.25 9.5 6.25H12C13.9228 6.25 15.7669 7.01384 17.1265 8.37348C18.4862 9.73311 19.25 11.5772 19.25 13.5C19.25 15.4228 18.4862 17.2669 17.1265 18.6265C15.7669 19.9862 13.9228 20.75 12 20.75Z"
                        fill="currentColor"
                      />
                      <path
                        d="M12 10.75C11.9015 10.7505 11.8038 10.7313 11.7128 10.6935C11.6218 10.6557 11.5392 10.6001 11.47 10.53L8.47 7.53003C8.32955 7.38941 8.25066 7.19878 8.25066 7.00003C8.25066 6.80128 8.32955 6.61066 8.47 6.47003L11.47 3.47003C11.5387 3.39634 11.6215 3.33724 11.7135 3.29625C11.8055 3.25526 11.9048 3.23322 12.0055 3.23144C12.1062 3.22966 12.2062 3.24819 12.2996 3.28591C12.393 3.32363 12.4778 3.37977 12.549 3.45099C12.6203 3.52221 12.6764 3.60705 12.7141 3.70043C12.7518 3.79382 12.7704 3.89385 12.7686 3.99455C12.7668 4.09526 12.7448 4.19457 12.7038 4.28657C12.6628 4.37857 12.6037 4.46137 12.53 4.53003L10.06 7.00003L12.53 9.47003C12.6704 9.61066 12.7493 9.80128 12.7493 10C12.7493 10.1988 12.6704 10.3894 12.53 10.53C12.4608 10.6001 12.3782 10.6557 12.2872 10.6935C12.1962 10.7313 12.0985 10.7505 12 10.75Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span *ngIf="!item.auditRerunning"> Rerun Audit </span>
                    <span *ngIf="item.auditRerunning"> Rerunning... </span>
                  </div>
                </button>

                <div class="custom_table-editButton">
                  <i
                    class="fa fa-trash"
                    aria-hidden="true"
                    (click)="openDeleteAudit(item)"
                  ></i>
                </div>
              </div>
            </td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>

      <div class="audits-loading-more" *ngIf="loadingMore">Loading more…</div>

      <div
        class="audits-empty"
        *ngIf="(!tasks || tasks.length === 0) && !isLoading"
      >
        No data found.
      </div>
    </div>

    <!-- loader overlay -->
    <div class="loading-data-overlay" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>

  <!-- skeleton loaders -->
  <ng-container *ngIf="firstLoader">
    <div style="padding: 20px" class="bar-chart-box" fxLayout="column">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '50px',
          width: '30%',
          outline: 'none',
          'background-color': '#37474f1a',
          'margin-bottom': '20px',
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '220px',
          outline: 'none',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
    </div>
  </ng-container>
</div>
